<button
  type="button"
  aria-pressed="false"
  class="relative inline-flex h-6 w-11 cursor-pointer items-center transition-colors focus:outline-none"
  [disabled]="disabled"
  (click)="toggle()"
  [attr.data-pendo-id]="pendoId"
>
  <span
    class="h-1.5 w-full rounded-full duration-200 ease-in-out"
    [ngClass]="{
      'bg-aux-blue': fc.value,
      'bg-gray-200': !fc.value,
    }"
  ></span>

  <span
    aria-hidden="true"
    class="absolute h-6 w-6 transform rounded-full border bg-white shadow ring-0 transition duration-200 ease-in-out"
    [ngClass]="{
      'translate-x-5 border-aux-blue': fc.value,
      'translate-x-0 border-gray-200': !fc.value,
    }"
  ></span>
</button>
